import CountUp from 'countup.js';
import inView from 'in-view';

let el = '.js-countup';

function init() {
  // check for el
  if (!document.body.contains(document.querySelector(el))) {
    return;
  }

  inView('.js-countup').on('enter', function() {
    $('.js-countup').each(function() {
      let start = 0;
      let end = $(this).attr('data-end');
      let numAnim = new CountUp(this, start, end, 0, 3);

      if (!numAnim.error) {
        numAnim.start();
      }
    });
  });
}

export default {
  init,
}



// WEBPACK FOOTER //
// ./scripts/comps/countup.js